/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ApplicationView,
  BuilderOfficeData,
  BuilderUserProfileDto,
  SystemRoleBit,
  UserType,
} from '@gh/builder-shared-data';
import { UserContext } from '@gh/common-shared';
import { MasterZoneData } from '@gh/common-shared-data';

export type BuilderUserData = BuilderUserProfileDto;

export abstract class BuilderUserContext extends UserContext {
  abstract get office(): Maybe<BuilderOfficeData>;

  abstract get masterZone(): Maybe<MasterZoneData>;

  abstract get applicationView(): ApplicationView;

  abstract get sandbox(): boolean;

  abstract get officeView(): boolean;

  abstract get masterView(): boolean;

  abstract get corporateView(): boolean;

  abstract get userType(): UserType;

  abstract get colorScheme(): string;

  abstract isSwitched(): boolean;

  abstract hasSystemRole(role: SystemRoleBit): boolean;

  abstract changeColorScheme(schema: string): void;
}
